import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import FeaturedCaseStudy from '../components/FeaturedCaseStudy';
import Portfolio from '../components/Portfolio';
import WhyUs from '../components/WhyUs';
import ProcessTimeline from '../components/ProcessTimeline';
import Testimonials from '../components/Testimonials';
import Blog from '../components/Blog';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import InteractiveBackground from '../components/InteractiveBackground';

export default function HomePage() {
  const [selectedService, setSelectedService] = useState('');

  return (
    <div className="min-h-screen bg-[#F8F5F0] text-[#3E2F24] selection:bg-[#8B6B4A]/20 selection:text-[#3E2F24]">
      {/* Interactive Antigravity Particle Flow Background */}
      <InteractiveBackground />

      {/* Dynamic Background Grid Pattern & Glow System */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        {/* Soft Faded Luxury Blobs */}
        <div className="absolute top-[20%] left-[-10%] w-[50vw] h-[50vw] rounded-full bg-[#C8A97E] opacity-[0.06] blur-[150px] animate-pulse-slow" />
        <div className="absolute bottom-[20%] right-[-10%] w-[50vw] h-[50vw] rounded-full bg-[#D6C2A8] opacity-[0.05] blur-[150px] animate-pulse-slow-reverse" />
        <div className="absolute top-[60%] right-[20%] w-[40vw] h-[40vw] rounded-full bg-[#8B6B4A] opacity-[0.04] blur-[120px] animate-pulse-slow" />
      </div>

      <div className="relative z-10">
        <Header />
        <Hero />
        <Services onSelectService={setSelectedService} />
        <FeaturedCaseStudy />
        <Portfolio />
        <WhyUs />
        <ProcessTimeline />
        <Testimonials />
        <Blog />
        <Contact selectedService={selectedService} setSelectedService={setSelectedService} />
        <Footer />
      </div>
    </div>
  );
}